import { createAction, props } from '@ngrx/store';
import {
  BasketSearchResult,
  UserBasketsSearchResult,
} from 'graphql-api/baskets-api-interfaces';

export const searchGroupedBaskets = createAction(
  '[Basket] Search User Grouped Baskets',
  props<{ refNumber?: string; amountToLoad?: number; start?: number }>(),
);

export const searchGroupedBasketsSuccess = createAction(
  '[Basket] Search User Grouped Baskets Success',
  props<{ data?: UserBasketsSearchResult | null }>(),
);

export const searchGroupedBasketsFailure = createAction(
  '[Basket] Search Grouped Baskets Failure',
  props<{ error: string }>(),
);

export const searchBaskets = createAction(
  '[Basket] Search Baskets',
  props<{ refNumber?: string; amountToLoad?: number; start?: number }>(),
);

export const searchBasketsSuccess = createAction(
  '[Basket] Search Baskets Success',
  props<{ data: BasketSearchResult | null }>(),
);

export const searchBasketsFailure = createAction(
  '[Basket] Search Baskets Failure',
  props<{ error: string }>(),
);

export const clearPaginationData = createAction(
  '[Basket] Clear Pagination Data',
);

export const openBasketManager = createAction('[Basket] Open Basket Manager');

export const closeBasketManager = createAction('[Basket] Close Basket Manager');
